module.exports = __webpack_public_path__ + "static/avatar-f1c7571a98a87236c2756c7ef25316c8.jpg";